import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAccounts } from '../../api/account';
import { Account } from '../../types/model/account';
import { setLoading } from '../../store/UI';
import AccountsTable from '../../components/Accounts/AccountsTable';

const Accounts = () => {
  const dispatch = useDispatch();
  const [accounts, setAccounts] = React.useState<Account[]>([]);
  const isAdministrator = useSelector(
    (state: any) => state.session?.isAdministrator
  );

  const fetchAccounts = async () => {
    try {
      dispatch(setLoading(true));
      const data = await getAccounts();
      setAccounts(data);
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(setLoading(false));
    }
  };

  useEffect(() => {
    fetchAccounts();
  }, []);

  const handleRequestRefresh = () => {
    fetchAccounts();
  };

  return (
    <AccountsTable
      tableData={accounts}
      onRequestRefresh={handleRequestRefresh}
      showAddButton={isAdministrator}
    />
  );
};

export default Accounts;
